import React from 'react';
import _ from 'lodash';
import timeSolver from "timesolver/timeSolver.min";
import DatePicker from "react-datepicker";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import "react-datepicker/dist/react-datepicker.css";
import { Document, Font, Page, View, Text, Image, StyleSheet, pdf, PDFViewer } from '@react-pdf/renderer';

const HOME_URL = window.wpApiSettings.fiq_home_url;
const AJAX_URL = window.wpApiSettings.fiq_ajax_url;
const UPLOADS_URL = window.wpApiSettings.fiq_upload_url;
const TRAINERS = window.wpApiSettings.fiq_trainers;
const SITEADMINS = window.wpApiSettings.fiq_siteadmins;
const USERROLE = window.wpApiSettings.fiq_current_user_role;

class Inspectors extends React.Component {
	constructor(props) {
		super();

		this.state = {
			saved_success: false,
			saved_error: false,
			user: props.user,
		};

		this.saveOptions = this.saveOptions.bind(this);
		this.changeOptions = this.changeOptions.bind(this);
		this.changeDate = this.changeDate.bind(this);
		this.saveInspector = this.saveInspector.bind(this);
		this.createCertPDF = this.createCertPDF.bind(this);
		this.createIdPDF = this.createIdPDF.bind(this);
		this.revokeCert = this.revokeCert.bind(this);
		this.formatDate = this.formatDate.bind(this);
	}

	saveOptions(user) {
		fetch(AJAX_URL, {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
			body: 'action=fiq_save_options&data=' + JSON.stringify(user),
			credentials: 'same-origin'
		}).then(data => {
			if (data.ok) {
				this.setState({ saved_success: true });
				setTimeout(() => {
					this.setState({ saved_success: false });
				}, 2500);
			} else {
				this.setState({ saved_error: true });
				setTimeout(() => {
					this.setState({ saved_error: false });
				}, 2500);
			}
		});
	}

	changeOptions(event) {
		var { target: { name, value } } = event;
		this.setState(prevState => {
			var user = Object.assign({}, prevState.user);
			_.set(user, name, value);
			return { user };
		});
	}

	changeDate(date, name) {
		this.setState(prevState => {
			var user = Object.assign({}, prevState.user);
			_.set(user, name, date);
			return { user };
		});
	}

	saveInspector(event, user) {
		if (event) { event.preventDefault(); }
		this.props.onSelectInspector(user);
		this.setState(prevState => {
			var user = Object.assign({}, prevState.user);
			_.set(user, 'action', 'email_inspector');
			this.saveOptions(user);
			return { user };
		});
	}

	revokeCert(user, type) {
		this.setState(prevState => {
			var user = Object.assign({}, prevState.user);
			_.set(user, 'action', 'email_revoked');
			_.set(user, type + '_cert_status', '');
			_.set(user, type + '_expiration_date', '');
			_.set(user, type + '_cert_path', '');
			_.set(user, type + '_id_path', '');
			this.saveOptions(user);
			return { user };
		});
	}

	revokeID(user, type) {
		//console.log(user, type);
		this.setState(prevState => {
			var user = Object.assign({}, prevState.user);
			_.set(user, 'action', 'id_revoked');
			_.set(user, type + '_cert_status', '');
			_.set(user, type + '_expiration_date', '');
			_.set(user, type + '_cert_path', '');
			_.set(user, type + '_id_path', '');
			this.saveOptions(user);
			return { user };
		});
	}

	createCertPDF(user, type) {
		let course = (type == 'ssf') ? 'AAADM Certified Swing/Slide/Fold Automatic Pedestrian Door Inspector' : 'AAADM Certified Revolving Automatic Pedestrian Door Inspector';
		let certified = (type == 'ssf') ? 'A156.10, A156.19, A156.38' : 'A156.27';
		let cert_num = user[type + "_cert_num"];

		//let award_date = user[type + "_award_date"];
		// let expiration_date = this.formatDate(new Date(new Date().getFullYear() + 1, 11, 31));
		// let expiration_date = this.formatDate(new Date(2024, 0, 31));
		let expirationDate = user[type + "_expiration_date"];

		if (!course || !cert_num || !expirationDate) {
			var error_temp = '';
			if (!course) { error_temp += "• Course Name is Required\n"; }
			if (!cert_num) { error_temp += "• Certificate Number is Required\n" }
			//if (!award_date) { error_temp += "• Certificate Award Date is Required\n" }
			alert("Cannot generate certificate!\nRequired info is missing for the following fields:\n\n" + error_temp);
		} else {
			expirationDate = this.formatDate(expirationDate);
			var date_str = new Date(expirationDate);
			let mo = new Intl.DateTimeFormat('en', { month: 'long' }).format(date_str);
			let da = new Intl.DateTimeFormat('en', { day: 'numeric' }).format(date_str);
			let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date_str);
			const Certificate = () => (
				<Document>
					<Page style={styles.body} size='letter' orientation='landscape'>
						<Image style={styles.image} src={HOME_URL + "/wp-content/plugins/fiq-cert-manager/cert-manager/certs/certificate-bg.jpg"} />
						<Text style={styles.name} >{user.first_name} {user.last_name} #{cert_num}</Text>
						<Text style={styles.course} >{course}</Text>
						<Text style={styles.exp_date} >Expires: {mo} {da}, {ye}</Text>
						<Text style={styles.certified} >{certified}</Text>
					</Page>
				</Document>
			);

			const styles = StyleSheet.create({
				body: { fontFamily: 'Helvetica', position: 'relative', backgroundColor: '#000000' },
				image: { position: 'absolute', top: '0', left: '0', height: '100%', width: '100%' },
				name: { fontSize: 30, color: '#000000', position: 'absolute', top: '42%', left: '6.6%', width: '80%', textAlign: 'left' },
				course: { fontSize: 20, color: '#173752', position: 'absolute', top: '59%', left: '6.6%', width: '80%', textAlign: 'left' },
				certified: { fontSize: 10, color: '#ffffff', position: 'absolute', top: '90%', left: '6.6%', width: '80%', textAlign: 'left' },
				exp_date: { fontSize: 20, color: '#000000', position: 'absolute', top: '48%', left: '6.6%', width: '80%', textAlign: 'left' },
			});

			pdf(<Certificate />).toBlob().then(data => {
				var formdata = new FormData()
				formdata.append('data', data);
				formdata.append('type', 'certificate');
				formdata.append('action', 'fiq_save_blob');
				formdata.append('name', 'certificate-' + type + '-' + user.first_name + '-' + user.last_name);

				this.setState(prevState => {
					var user = Object.assign({}, prevState.user);
					_.set(user, type + '_cert_path', '');
					return { user };
				});

				fetch(AJAX_URL, {
					method: 'POST',
					body: formdata,
					credentials: 'same-origin'
				}).then(data => {
					return data.json();
				}).then(data => {
					if (data) {
						this.setState({ saved_success: true });
						this.setState(prevState => {
							//let expirationDate = timeSolver.getString(new Date(new Date().getFullYear() + 1, 11, 31), "MM/DD/YYYY");
							let value = HOME_URL + '/wp-content/uploads/cert-manager/' + data; //console.log(value);
							var user = Object.assign({}, prevState.user);
							_.set(user, 'action', 'email_issued');
							_.set(user, type + '_cert_path', value);
							_.set(user, type + '_cert_status', 'Certified');
							_.set(user, type + '_expiration_date', expirationDate);
							this.saveOptions(user);
							return { user };
						});
						setTimeout(() => { this.setState({ saved_success: false }); }, 2500);
						return true;
					} else {
						this.setState({ saved_error: true });
						setTimeout(() => { this.setState({ saved_error: false }); }, 2500);
						return false;
					}
				}).catch(error => console.log(error));
			});
		}
	}

	createIdPDF(user, type) {
		let course = (type == 'ssf') ? 'AAADM Certified Swing/Slide/Fold' : 'AAADM Certified Revolving';
		let course2 = 'Automatic Pedestrian Door Inspector';
		let certified = (type == 'ssf') ? 'A156.10, A156.19, A156.38' : 'A156.27';
		let cert_path = user[type + "_cert_path"];
		let cert_num = user[type + "_cert_num"];
		// let expiration_date = this.formatDate(new Date(new Date().getFullYear() + 1, 11, 31));
		// let expiration_date = this.formatDate(new Date(2024, 0, 31));

		let expiration_date = user[type + "_expiration_date"];

		console.log(user);

		if (!cert_path) {
			alert("You must generate the certificate before creating an ID.");
		} else {
			expiration_date = this.formatDate(expiration_date);
			var date_str = new Date(expiration_date);
			let mo = new Intl.DateTimeFormat('en', { month: 'long' }).format(date_str);
			let da = new Intl.DateTimeFormat('en', { day: 'numeric' }).format(date_str);
			let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date_str);
			const Identification = () => (
				<Document>
					<Page style={styles.body} size='letter' orientation='portrait'>
						<Image style={styles.image} src={HOME_URL + "/wp-content/plugins/fiq-cert-manager/cert-manager/ids/id-bg.jpg"} />
						<Text style={styles.name} >{user.first_name} {user.last_name} #{cert_num}</Text>
						<Text style={styles.course} >{course}</Text>
						<Text style={styles.course2} >{course2}</Text>
						<Text style={styles.expiry} >Expires: {mo}, {da} {ye}</Text>
						<Text style={styles.certified} >{certified}</Text>
					</Page>
				</Document>
			);

			const styles = StyleSheet.create({
				body: { fontFamily: 'Helvetica', backgroundColor: '#ffffff', width: '100vw' },
				image: { margin: '29vw', height: '23.52941176vw', width: '41.17647059vw' },
				name: { fontSize: 12, fontWeight: 900, color: '#000000', position: 'absolute', top: '30.7%', left: '26.7%', width: '60%', textAlign: 'center' },
				expiry: { fontSize: 10, fontWeight: 300, color: '#000000', position: 'absolute', top: '32.2%', left: '26.7%', width: '60%', textAlign: 'center' },
				course: { fontSize: 7, fontWeight: 300, color: '#173752', position: 'absolute', top: '35.2%', left: '26.7%', width: '60%', textAlign: 'center' },
				course2: { fontSize: 7, fontWeight: 300, color: '#173752', position: 'absolute', top: '35.9%', left: '26.7%', width: '60%', textAlign: 'center' },
				certified: { fontSize: 4.5, color: '#ffffff', position: 'absolute', top: '38.5%', left: '30%', width: '80%', textAlign: 'left' },
			});

			pdf(<Identification />).toBlob().then(data => {
				var formdata = new FormData()
				formdata.append('data', data);
				formdata.append('type', 'identification');
				formdata.append('action', 'fiq_save_blob');
				formdata.append('name', 'identification-' + type + '-' + user.first_name + '-' + user.last_name);

				this.setState(prevState => {
					var user = Object.assign({}, prevState.user);
					_.set(user, type + '_id_path', '');
					return { user };
				});

				fetch(AJAX_URL, {
					method: 'POST',
					body: formdata,
					credentials: 'same-origin'
				}).then(data => {
					return data.json();
				}).then(data => {
					if (data) {
						this.setState({ saved_success: true });
						this.setState(prevState => {
							let value = HOME_URL + '/wp-content/uploads/cert-manager/' + data;
							var user = Object.assign({}, prevState.user);
							_.set(user, type + '_id_path', value);
							this.saveOptions(user);
							return { user };
						});
						setTimeout(() => { this.setState({ saved_success: false }); }, 2500);
						return true;
					} else {
						this.setState({ saved_error: true });
						setTimeout(() => { this.setState({ saved_error: false }); }, 2500);
						return false;
					}
				}).catch(error => console.log(error));
			});
		}
	}

	formatDate(date) {
		var d = new Date(date), month = '' + (d.getMonth() + 1), day = '' + d.getDate(), year = d.getFullYear();
		if (month.length < 2) { month = '0' + month; }
		if (day.length < 2) { day = '0' + day; }
		var dtemp = [year, month, day].join('-') + 'T00:00:00'
		return dtemp;
	}

	render() {
		const ssf_trainer_name = (this.state.user.ssf_trainer_id) ? (TRAINERS.find(obj => obj.id == this.state.user.ssf_trainer_id) || {}).company : '';
		const ssf_exp_date = (this.state.user.ssf_expiration_date) ? this.formatDate(new Date(this.state.user.ssf_expiration_date)) : '';
		//console.log(ssf_exp_date);
		const ssf_cert_status = this.state.user.ssf_cert_status; //console.log(ssf_cert_status);
		const ssf_cert_num = this.state.user.ssf_cert_num; //console.log(ssf_cert_num);

		const rev_trainer_name = (this.state.user.rev_trainer_id) ? TRAINERS.find(obj => obj.id == this.state.user.rev_trainer_id) || {}.company : '';
		const rev_exp_date = (this.state.user.rev_expiration_date) ? this.formatDate(new Date(this.state.user.rev_expiration_date)) : '';
		const rev_cert_status = this.state.user.rev_cert_status;
		const rev_cert_num = this.state.user.rev_cert_num;

		const todays_date = this.formatDate(new Date());
		return (
			<form className={'user_' + this.state.user.id} onSubmit={(e) => this.saveInspector(e, this.state.user)}>
				<div>
					<Tabs defaultIndex={0} className="react-tabs fiq-user-tabs">
						<TabList className='react-tabs__tab-list'>
							<Tab>Profile</Tab>
							<Tab>Certificate</Tab>
							<Tab>Identification</Tab>
						</TabList>
						<TabPanel>
							<div className="columns w50">
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>Site Admin</strong></label></div>
									<div className='input iconField'>
										<select name='siteadmin_id' className='text-input' disabled={(USERROLE == "inspector") ? "disabled" : ""} value={this.state.user.siteadmin_id} onChange={(e) => this.changeOptions(e)}>
											<option value="" key='-1'>Select</option>
											{
												SITEADMINS.map(function (siteadmin) {
													return (
														<option value={siteadmin.id} key={siteadmin.id}>{siteadmin.company}</option>
													);
												}, this)
											}
										</select>
										<i className="dashicons dashicons-welcome-learn-more"></i>
									</div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>First Name</strong></label></div>
									<div className='input iconField'><input name='first_name' type='text' value={this.state.user.first_name} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="dashicons dashicons-admin-users"></i></div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>Last Name</strong></label></div>
									<div className='input iconField'><input name='last_name' type='text' value={this.state.user.last_name} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="dashicons dashicons-admin-users"></i></div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>Address</strong></label></div>
									<div className='input iconField'><input name='address' type='text' value={this.state.user.address} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="dashicons dashicons-admin-home"></i></div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>City</strong></label></div>
									<div className='input iconField'><input name='city' type='text' value={this.state.user.city} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="dashicons dashicons-building"></i></div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>State</strong></label></div>
									<div className='input iconField'><input name='state' type='text' value={this.state.user.state} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="dashicons dashicons-bank"></i></div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>Zip Code</strong></label></div>
									<div className='input iconField'><input name='zip' type='text' value={this.state.user.zip} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="dashicons dashicons-location"></i></div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>Phone Number</strong></label></div>
									<div className='input iconField'><input name='phone' type='text' value={this.state.user.phone} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="dashicons dashicons-phone"></i></div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>Email Address</strong></label></div>
									<div className='input iconField'><input name='user_email' type='text' value={this.state.user.user_email} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="dashicons dashicons-email"></i></div>
								</div>
								<div htmlFor='fc_text_item' className='fc_row'>
									<div className='label'><label><strong>Company Name</strong></label></div>
									<div className='input iconField'><input name='company' type='text' value={this.state.user.company} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="dashicons dashicons-portfolio"></i></div>
								</div>
							</div>
							<div className="columns w50">
								<div className="cert-box">
									<h4>{this.state.user.ssf_order_course}</h4>
									<hr />
									<div className='fc_row fc-order-details'>
										{(this.state.user.ssf_trainer_id) ? <span><strong>Trainer:</strong> {ssf_trainer_name}</span> : ''}
										{(this.state.user.ssf_order_date) ? <span><strong>Training Date:</strong> {new Date(this.state.user.ssf_order_date).toLocaleDateString()}</span> : ''}
										{(this.state.user.ssf_expiration_date) ? <span><strong>Expiration Date:</strong> {new Date(this.state.user.ssf_expiration_date).toLocaleDateString()}</span> : ''}
										{(this.state.user.ssf_order_num) ? <span><strong>Order#:</strong> {this.state.user.ssf_order_num}</span> : ''}
										{(this.state.user.ssf_cert_status) && (<span className={this.state.user.ssf_cert_status}><i className="dashicons"></i>{this.state.user.ssf_cert_status}</span>)}

										{(ssf_exp_date && ssf_exp_date > todays_date && ssf_cert_num && !ssf_cert_status) && (<span className="Not-Generated"><i className="dashicons"></i>Please generate your cert in the Certificate Tab</span>)}
										{(ssf_exp_date && ssf_exp_date > todays_date && !ssf_cert_num) && (<span className="Not-Generated"><i className="dashicons"></i>Cert# and Award Date needed to complete certification</span>)}
										{(ssf_exp_date && ssf_exp_date < todays_date) && (<span className="Expired"><i className="dashicons"></i>Certificate Expired - Renew Now</span>)}
										{(!ssf_exp_date) && (<span className="Expired"><i className="dashicons"></i>NO Certificate found - Purchase one using our online store</span>)}
									</div>
									{(ssf_exp_date > todays_date) && (
									<div>
										<hr />
										<div htmlFor='fc_text_item' className='fc_row'>
											<div className='label'><label><strong>Cert Number</strong></label></div>
											<div className="input iconField"><input name='ssf_cert_num' type='text' disabled={(USERROLE == "inspector") ? "disabled" : ""} value={this.state.user.ssf_cert_num} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="hashtag"></i></div>
										</div>
									</div>
									)}
								</div>
								<div className="cert-box">
									<h4>{this.state.user.rev_order_course}</h4>
									<hr />
									<div className='fc_row fc-order-details'>
										{(this.state.user.rev_trainer_id) ? <span><strong>Trainer:</strong> {TRAINERS.find(obj => obj.id === this.state.user.rev_trainer_id)?.company || 'N/A'}</span> : ''}
										{(this.state.user.rev_order_date) ? <span><strong>Training Date:</strong> {new Date(this.state.user.rev_order_date).toLocaleDateString()}</span> : ''}
										{(this.state.user.rev_expiration_date) ? <span><strong>Expiration Date:</strong> {new Date(this.state.user.rev_expiration_date).toLocaleDateString()}</span> : ''}
										{(this.state.user.rev_order_num) ? <span><strong>Order#:</strong> {this.state.user.rev_order_num}</span> : ''}
										{(this.state.user.rev_cert_status) ? <span className={this.state.user.rev_cert_status}><i className="dashicons"></i>{this.state.user.rev_cert_status}</span> : ''}

										{(rev_exp_date && rev_exp_date > todays_date && rev_cert_num && !rev_cert_status) && (<span className="Not-Generated"><i className="dashicons"></i>Please generate your cert in the Certificate Tab</span>)}
										{(rev_exp_date && rev_exp_date > todays_date && !rev_cert_num) && (<span className="Not-Generated"><i className="dashicons"></i>Cert# and Award Date needed to complete certification</span>)}
										{(rev_exp_date && rev_exp_date < todays_date) && (<span className="Expired"><i className="dashicons"></i>Certificate Expired - Renew Now</span>)}
										{(!rev_exp_date) && (<span className="Expired"><i className="dashicons"></i>NO Certificate found - Purchase one using our online store</span>)}
									</div>
									{(rev_exp_date > todays_date) && (
									<div>
										<hr />
										<div htmlFor='fc_text_item' className='fc_row'>
											<div className='label'><label><strong>Cert Number</strong></label></div>
											<div className="input iconField"><input name='rev_cert_num' type='text' disabled={(USERROLE == "inspector") ? "disabled" : ""} value={this.state.user.rev_cert_num} className='text-input' onChange={(e) => this.changeOptions(e)} /><i className="hashtag"></i></div>
										</div>
									</div>
									)}
								</div>
							</div>
							<input type='submit' value='Save Changes' className='button button-primary' />
						</TabPanel>
						<TabPanel>
							<div>
								<h2>{this.state.user.ssf_order_course} -- Certificate</h2>
								{!this.state.user.ssf_cert_path && (
									<div style={{ height: '330px', width: '450px' }}>
										<img src={HOME_URL + "/wp-content/plugins/fiq-cert-manager/cert-manager/certs/certificate-none.jpg"} />
									</div>
								)}
								{this.state.user.ssf_cert_path && (
									<div style={{ height: '350px', width: '450px' }}>
										<iframe src={(this.state.user.ssf_cert_path) ? this.state.user.ssf_cert_path + "#toolbar=0" : ''} width="450px" height="350px" frameBorder="0"></iframe>
									</div>
								)}
								<div>
									{(!ssf_exp_date) && (<span className="Expired"><i className="dashicons"></i>NO Certificate found - Purchase one using our online store</span>)}
									{(ssf_exp_date && ssf_exp_date < todays_date) && (<span className='msg-failed error'><i className={'dashicons dashicons-warning'}></i> Certificate has expired! You must renew in order to generate a new certificate.</span>)}
									{(ssf_exp_date && ssf_exp_date > todays_date) && (<span><input type='button' value='Generate Cert' className='button button-secondary' onClick={(user) => this.createCertPDF(this.state.user, "ssf")} /> &nbsp;</span>)}
									{this.state.user.ssf_cert_path && USERROLE == "administrator" && (<span><input type='button' value='Revoke Cert' className='button button-secondary' onClick={(user) => this.revokeCert(this.state.user, "ssf")} /> &nbsp;</span>)}
									{this.state.user.ssf_cert_path && (<a href={this.state.user.ssf_cert_path} className='button button-secondary'>Download Certificate</a>)}
								</div>
							</div>
							<div>
								<h2>{this.state.user.rev_order_course} -- Certificate</h2>
								{!this.state.user.rev_cert_path && (
									<div style={{ height: '330px', width: '450px' }}>
										<img src={HOME_URL + "/wp-content/plugins/fiq-cert-manager/cert-manager/certs/certificate-none.jpg"} />
									</div>
								)}
								{this.state.user.rev_cert_path && (
									<div style={{ height: '350px', width: '450px' }}>
										<iframe src={(this.state.user.rev_cert_path) ? this.state.user.rev_cert_path + "#toolbar=0" : ''} width="450px" height="350px" frameBorder="0"></iframe>
									</div>
								)}
								<div>
									{(!rev_exp_date) && (<span className="Expired"><i className="dashicons"></i>NO Certificate found - Purchase one using our online store</span>)}
									{(rev_exp_date && rev_exp_date < todays_date) && (<span className='msg-failed error'><i className={'dashicons dashicons-warning'}></i> Certificate has expired! You must renew in order to generate a new certificate.</span>)}
									{(rev_exp_date && rev_exp_date > todays_date) && (<span><input type='button' value='Generate Cert' className='button button-secondary' onClick={(user) => this.createCertPDF(this.state.user, "rev")} /> &nbsp;</span>)}
									{this.state.user.rev_cert_path && USERROLE == "administrator" && (<span><input type='button' value='Revoke Cert' className='button button-secondary' onClick={(user) => this.revokeCert(this.state.user, "rev")} /> &nbsp;</span>)}
									{this.state.user.rev_cert_path && (<a href={this.state.user.rev_cert_path} className='button button-secondary'>Download Certificate</a>)}
								</div>
							</div>
						</TabPanel>
						<TabPanel>
							<div>
								<h2>{this.state.user.ssf_order_course} -- Identification</h2>
								{!this.state.user.ssf_id_path && (
									<div style={{ height: '270px', width: '450px' }}>
										<img src={HOME_URL + "/wp-content/plugins/fiq-cert-manager/cert-manager/ids/id-none.jpg"} />
									</div>
								)}
								{this.state.user.ssf_id_path && (
									<div style={{ height: '270px', width: '450px' }}>
										<iframe src={(this.state.user.ssf_id_path) ? this.state.user.ssf_id_path + "#toolbar=0" : ''} width="450px" height="252px" frameBorder="0"></iframe>
									</div>
								)}
								<div>
									{(!ssf_exp_date) && (<span className="Expired"><i className="dashicons"></i>NO identification found - Purchase one using our online store</span>)}
									{(ssf_exp_date && ssf_exp_date < todays_date) && (<span className='msg-failed error'><i className={'dashicons dashicons-warning'}></i> ID has expired! You must renew in order to generate a new ID.</span>)}
									{(ssf_exp_date && ssf_exp_date > todays_date) && (<span><input type='button' value='Generate ID' className='button button-secondary' onClick={(user) => this.createIdPDF(this.state.user, "ssf")} /> &nbsp;</span>)}
									{this.state.user.ssf_id_path && USERROLE == "administrator" && (<span><input type='button' value='Revoke ID' className='button button-secondary' onClick={(user) => this.revokeID(this.state.user, "ssf")} /> &nbsp;</span>)}
									{this.state.user.ssf_id_path && (<a href={this.state.user.ssf_id_path} className='button button-secondary'>Download ID Card</a>)}
								</div>
							</div>
							<div>
								<h2>{this.state.user.rev_order_course} -- Identification</h2>
								{!this.state.user.rev_id_path && (
									<div style={{ height: '270px', width: '450px' }}>
										<img src={HOME_URL + "/wp-content/plugins/fiq-cert-manager/cert-manager/ids/id-none.jpg"} />
									</div>
								)}
								{this.state.user.rev_id_path && (
									<div style={{ height: '270px', width: '450px' }}>
										<iframe src={(this.state.user.rev_id_path) ? this.state.user.rev_id_path + "#toolbar=0" : ''} width="450px" height="252px" frameBorder="0"></iframe>
									</div>
								)}
								<div>
									{(!rev_exp_date) && (<span className="Expired"><i className="dashicons"></i>NO identification found - Purchase one using our online store</span>)}
									{(rev_exp_date && rev_exp_date < todays_date) && (<span className='msg-failed error'><i className={'dashicons dashicons-warning'}></i> ID has expired! You must renew in order to generate a new ID.</span>)}
									{(rev_exp_date && rev_exp_date > todays_date) && (<span><input type='button' value='Generate ID' className='button button-secondary' onClick={(user) => this.createIdPDF(this.state.user, "rev")} /> &nbsp;</span>)}
									{this.state.user.rev_id_path && USERROLE == "administrator" && (<span><input type='button' value='Revoke ID' className='button button-secondary' onClick={(user) => this.revokeID(this.state.user, "rev")} /> &nbsp;</span>)}
									{this.state.user.rev_id_path && (<a href={this.state.user.rev_id_path} className='button button-secondary'>Download ID Card</a>)}
								</div>
							</div>
						</TabPanel>
					</Tabs>
					<div>
						<span className={this.state.saved_success ? 'msg-success saved' : 'msg-success'}><i className={'dashicons dashicons-yes-alt'}></i> Success: User information saved successfully</span>
						<span className={this.state.saved_error ? 'msg-failed error' : 'msg-failed'}><i className={'dashicons dashicons-warning'}></i> Error: There was an error saving your changes</span>
					</div>
				</div>
			</form >
		);
	}
}

export default Inspectors;
